import React, { useEffect, useState } from 'react'
import { Col, Modal, Row, Form } from 'react-bootstrap'
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import ReactSelect from "react-select";
import { customStyles } from "../../selectStyles";
import { useDispatch, useSelector } from 'react-redux';
import { fetchLanguage } from '../../redux/actions/LanguageAction';
import axios from '../../API/axios';
import toast from 'react-hot-toast';
import { useParams } from 'react-router-dom';
const UpdateLangugae = ({ setLanguageModal, languageModal, userDataId, getUserCv, userDataInfo }) => {
    console.log("userDataInfo", userDataInfo);

    // ...............................language DDL.......................................
    const sessionId = localStorage.getItem("sessionId");
    const userType = localStorage.getItem("userType");
    const { CandidateId } = useParams();
    const dispatch = useDispatch();

    const [formChanged, setFormChanged] = useState(false);


    const [language, setLanguage] = useState([]);
    const { LanguageList, selectedLanguageId } = useSelector(
        (state) => state.language
    );
    // console.log("language===>", LanguageList,formChanged);

    useEffect(() => {
        dispatch(fetchLanguage());
    }, [dispatch]);

    useEffect(() => {
        if (userDataInfo && userDataInfo.langIDs && userDataInfo.languages) {
            // 1. Combine langIDs and languages into { value, label } objects
            const combinedLanguages = userDataInfo.langIDs.map((id, index) => ({
                value: id,
                label: userDataInfo.languages[index] // Assuming the arrays are aligned by index
            }));
            // console.log("CombineLanguages===>",combinedLanguages)
            setLanguage(combinedLanguages);
        }
    }, [LanguageList, userDataInfo]);


    const handleLanguageSelect = (selectedOption) => {
        console.log("Selected Language===>", selectedOption)
        if (selectedOption) {
            setLanguage(selectedOption);
        } else {
            setLanguage(null);
        }

        setLanguage(selectedOption);
        setFormChanged(true); // Enable the Update button
    };
    // ...............................language DDL.......................................
    console.log("language", language);


    const multiLang = language.map((option) => option.value).join(",");
    console.log("multiLang:==>", multiLang);

    const handleSubmit = async (e) => {
        e.preventDefault();
        const body = {
            sessionId: sessionId,
            userDataId: userDataId,
            userType: userType,
            instnCnddtID: CandidateId === 'Candidate' ? null : CandidateId,
            langIDs: Array.isArray(multiLang)
                ? multiLang.flatMap(lang => lang.split(',').map(Number)) // Convert to an array of numbers
                : multiLang.split(',').map(Number) // Handle single string input
        };
        // console.log("update body", body);

        try {
            const res = await axios.post("/Resume/UpdateLanguages", body);
            console.log("updateres=====>", res);

            toast.success(res.data.message);
            setLanguageModal(false);
            setLanguage([])
            setFormChanged(false); // Disable the button after update
            getUserCv();
        } catch (error) {
            if (error.response && error.response.status === 404) {
                toast.error(error.response.data.message);
            } else {
                toast.error(error.response?.data?.title);
            }
        }
    };

    return (
        <>
            <Modal show={languageModal} onHide={() => { setLanguageModal(false) }} centered size="md">
                <Modal.Header >
                    <Modal.Title>Update language</Modal.Title>
                    <CloseSharpIcon className="pointer" onClick={() => { setLanguageModal(false) }} />
                </Modal.Header>
                <Modal.Body className="settings">
                    <Row>
                        <Col md={12}>
                            <Form.Group controlId="city">
                                <Form.Label className="class-type">
                                    Language
                                </Form.Label>
                                <div className="post-form-group">
                                    <ReactSelect
                                        options={LanguageList}
                                        onChange={handleLanguageSelect}
                                        value={language}
                                        placeholder="Select Language"
                                        classNamePrefix="react-select"
                                        className="form-control Dark-Input-from-group"
                                        styles={customStyles}
                                        isMulti
                                        isClearable
                                    />
                                </div>
                            </Form.Group>
                        </Col>
                    </Row>
                    <div className="add-class-submit-button mt-4 d-flex justify-content-center">
                        <div className="khojPrimaryBtn ms-3"
                            // onClick={handleSubmit}
                          style={{cursor: formChanged ? "pointer" : "default"}}
                        >
                            <a href="#/"
                                className={`btn ${formChanged ? "enabled" : "disabled"}`} // Optional: Add classes for styling
                                onClick={handleSubmit}
                                style={{ pointerEvents: formChanged ? "auto" : "none", border: "none" }}
                            >
                                Update
                            </a>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default UpdateLangugae